import type { JSX } from 'react';
import { XYCoord } from 'react-dnd';

import { DimensionsDragType } from '../EditModal.constants.js';
import ColumnOptionLayer from './CustomOptionLayer/index.js';
import DimensionRowLayer from './DimensionRowLayer/index.js';
import GroupItemLayer from './GroupedDimensionLayer/index.js';

type RenderProp = (props: {
  name: string;
  currentOffset: XYCoord;
  isNumericOption: boolean;
}) => JSX.Element;

export const mapDragTypeToDragLayer: Record<
  keyof typeof DimensionsDragType,
  RenderProp
> = {
  [DimensionsDragType.GROUPED_DIMENSION]: (props) => (
    <GroupItemLayer {...props} />
  ),
  [DimensionsDragType.DIMENSION_ROW]: (props) => (
    <DimensionRowLayer {...props} />
  ),
  [DimensionsDragType.SELECT_OPTION]: (props) => (
    <ColumnOptionLayer {...props} />
  ),
};
